module.exports = __webpack_public_path__ + "static/media/S (179).c8910f54.jpg";